var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBiochar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_91_1600",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#5D38E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_91_1600)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4377 117.626H117.499C118.825 117.626 119.899 116.551 119.899 115.226C119.899 113.9 118.825 112.826 117.499 112.826H53.6001C51.4117 112.826 49.6377 114.6 49.6377 116.788V127.365C49.6377 129.553 51.4117 131.327 53.6001 131.327H129.638C131.827 131.327 133.601 129.553 133.601 127.365V118.651C133.601 117.326 132.526 116.251 131.201 116.251C129.875 116.251 128.801 117.326 128.801 118.651V126.527H54.4377V117.626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3165 98.4893C37.3589 98.4811 37.4014 98.4741 37.4441 98.4682L47.7741 97.0424C49.0871 96.8612 50.2985 97.7787 50.4797 99.0917C50.6609 100.405 49.7434 101.616 48.4304 101.797L38.1645 103.214L33.088 104.196L33.9476 110.424C34.1288 111.737 33.2113 112.949 31.8983 113.13C30.5852 113.311 29.3739 112.394 29.1927 111.081L28.2271 104.085C27.9378 101.989 29.3384 100.032 31.4161 99.6305L37.3165 98.4893ZM78.1083 95.2784C77.9271 93.9654 78.8446 92.754 80.1577 92.5728L93.0356 90.7954C95.2145 90.4946 97.2246 92.0172 97.5253 94.1961L99.4336 108.022C99.7343 110.201 98.2118 112.211 96.0329 112.512L52.0823 118.578C50.7693 118.759 49.558 117.842 49.3767 116.529C49.1955 115.216 50.113 114.004 51.4261 113.823L94.5669 107.869L92.8822 95.662L80.8139 97.3277C79.5009 97.5089 78.2896 96.5914 78.1083 95.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2553 113.325L37.1022 120.61L77.1881 93.9402L72.3411 86.655L32.2553 113.325ZM26.7934 111.194C26.1343 111.632 25.9555 112.522 26.394 113.181L34.9708 126.072C35.4093 126.731 36.299 126.91 36.958 126.471L82.65 96.0716C83.309 95.6331 83.4878 94.7434 83.0493 94.0844L74.4725 81.1931C74.034 80.5341 73.1444 80.3553 72.4853 80.7938L26.7934 111.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2072 81.9751L89.9748 87.9L125.077 118.899L130.309 112.974L95.2072 81.9751ZM95.8609 76.1487C95.2676 75.6247 94.3619 75.6809 93.8379 76.2742L84.1484 87.2463C83.6244 87.8396 83.6806 88.7453 84.274 89.2693L124.423 124.726C125.017 125.25 125.922 125.193 126.446 124.6L136.136 113.628C136.66 113.035 136.604 112.129 136.01 111.605L95.8609 76.1487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6611 32.2758C49.8459 38.9918 52.7788 45.5812 58.3118 50.2158C63.8609 54.851 70.8704 56.5745 77.5082 55.5708C77.3232 48.855 74.3889 42.2663 68.8414 37.6319L68.28 37.1629C62.8268 32.8803 56.0706 31.3065 49.6611 32.2758ZM78.2024 38.3761C82.4282 44.2721 84.3344 51.4027 83.8413 58.422L83.679 60.7316L81.4346 61.2999C72.2418 63.6274 62.0689 61.694 54.2072 55.1263L54.2042 55.1237C46.3598 48.5541 42.6632 38.8885 43.3281 29.4245L43.4903 27.1149L45.7348 26.5467C54.9275 24.2191 65.1005 26.1525 72.9621 32.7203L78.2024 38.3761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0649 27.5967C45.1985 26.2409 47.2166 26.0607 48.5725 27.1943L82.719 55.7433C84.0748 56.8769 84.255 58.895 83.1214 60.2509C81.9878 61.6067 79.9697 61.7869 78.6138 60.6533L44.4673 32.1043C43.1115 30.9707 42.9313 28.9526 44.0649 27.5967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.3702 32.7203C96.2319 26.1525 106.405 24.2191 115.598 26.5467L117.842 27.1149L118.004 29.4245C118.669 38.8892 114.972 48.5563 107.108 55.1263C99.246 61.694 89.073 63.6274 79.8803 61.2999L77.6358 60.7316L77.4736 58.422C76.8087 48.9573 80.5059 39.2902 88.3702 32.7203ZM111.671 32.2758C105.033 31.2719 98.0228 32.9959 92.4734 37.6319C86.926 42.2663 83.9916 48.855 83.8066 55.5708C90.445 56.5746 97.4551 54.8507 103.004 50.2147C108.552 45.5803 111.486 38.9916 111.671 32.2758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.249 27.5961C118.383 28.9517 118.203 30.9698 116.848 32.1038L82.7186 60.6528C81.363 61.7867 79.3449 61.607 78.2109 60.2515C77.077 58.8959 77.2567 56.8778 78.6122 55.7438L112.741 27.1948C114.097 26.0609 116.115 26.2405 117.249 27.5961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.6658 52.8328C82.4331 52.8328 83.8658 54.2655 83.8658 56.0328V91.6442C83.8658 93.4116 82.4331 94.8442 80.6658 94.8442C78.8985 94.8442 77.4658 93.4116 77.4658 91.6442V56.0328C77.4658 54.2655 78.8985 52.8328 80.6658 52.8328Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBiochar);
export default __webpack_public_path__ + "static/media/icon_biochar.3937267690691dde456889d3e4184e69.svg";
export { ForwardRef as ReactComponent };